import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState(() => {
    // Load initial data from localStorage (if needed)
    const savedData = localStorage.getItem("authData");
    return savedData ? JSON.parse(savedData) : null;
  });

  const login = (data) => {
    setAuthData(data);
    localStorage.setItem("authData", JSON.stringify(data)); // Save to localStorage
  };

  const logout = () => {
    setAuthData(null);
    localStorage.removeItem("authData"); // Clear from localStorage
  };

  return (
    <AuthContext.Provider value={{ authData, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);